const normalizeRegistrationDate = (value) => {
  if (!value) return null;

  // Date simple
  if (value instanceof Date) {
    const d = value.toISOString().split('T')[0];
    return { dateFrom: d, dateTo: d };
  }

  // Rango
  if (typeof value === 'object') {
    const from =
      value.startDate instanceof Date
        ? value.startDate.toISOString().split('T')[0]
        : value.startDate || null;

    const to =
      value.endDate instanceof Date
        ? value.endDate.toISOString().split('T')[0]
        : value.endDate || null;

    return { dateFrom: from, dateTo: to };
  }

  return null;
};
export default normalizeRegistrationDate;
